import { ILeaseIngestion } from '@/bundles/LeaseIngestion/types';

import { ILeaseIngestionStore } from './index';

export default {
  recordById: (state: ILeaseIngestionStore) => (id: string): ILeaseIngestion | null => {
    return state.records[id] ?? null;
  },

  listForFilterKey: (state: ILeaseIngestionStore) => (key: string): ILeaseIngestion[] => {
    const listing = state.listings[key];
    if (!listing) return [];
    return listing.ids
      .map((id) => state.records[id])
      .filter((record): record is ILeaseIngestion => Boolean(record));
  },

  listingMeta: (state: ILeaseIngestionStore) => (key: string) => {
    return state.listings[key] ?? { ids: [], loading: false, error: null };
  },
};
